<nz-spin [nzSpinning]="loading">
  <nz-card>
<div>
  <button nz-button [nzType]="'primary'" class="default-button" (click)="showModal2()">
    <span nz-icon nzType="plus"></span>
    {{ "Add" |translate}}
  </button>
</div>

<div class="表格" style="margin-top: 10px;">
  <strong class="margin-left-8 result">{{ "Results" | translate}}({{nzTotal}})</strong>
  <nz-table #colSpanTable [nzData]="listOfData"  style="margin-bottom: 10px"
    nzSize="middle" nzShowSizeChanger [nzFrontPagination]="false" [nzShowPagination]='false' [nzPageSize]='pageSize'
    [nzPageIndex]='pageIndex' [nzScroll]="{ y: '700px',x:'2600px' }">
    <thead>
      <tr>
        <th scope="col" nzWidth="8%">{{ "BulletinType" | translate}}</th>
        <th scope="col" nzWidth="6%">{{ "Site" | translate}}</th>
        <th scope="col" nzWidth="10%">{{ "title" | translate}}</th>
        <th scope="col" nzWidth="10%">{{ "TraditionalTitle" | translate}}</th>
        <th scope="col" nzWidth="10%">{{ "EnglishTitle" | translate}}</th>
        <th scope="col" nzWidth="10%">{{ "VnTitle" | translate}}</th>
        <th scope="col" nzWidth="15%">{{ "CNtext" | translate}}</th>
        <th scope="col" nzWidth="15%">{{ "TWtext" | translate}}</th>
        <th scope="col" nzWidth="15%">{{ "ENtext" | translate}}</th>
        <th scope="col" nzWidth="15%">{{ "VNtext" | translate}}</th>
        <th  scope="col" nzWidth="10%">{{ "EffectiveDate" | translate}}</th>
        <th  scope="col" nzWidth="10%">{{ "ExpiryDate" | translate}}</th>
        <th scope="col" nzWidth="5%" [nzRight]="true">{{"Edit" | translate}}</th>
        <th scope="col" nzWidth="5%" [nzRight]="true">{{"act"| translate}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of colSpanTable.data;let i=index">
        <td *ngIf="data.typeNumber=='1'">{{"ExternalAnnouncement" | translate}}</td>
        <td *ngIf="data.typeNumber=='0'">{{"InternalAnnouncement" | translate}}</td>
        <td>{{data.siteName}}</td>
        <td>{{data.noticeTitle}}</td>
        <td>{{data.twNoticeTitle}}</td>
        <td>{{data.enNoticeTitle}}</td>
        <td>{{data.vnNoticeTitle}}</td>
        <td>{{data.chNoticeDetail}}</td>
        <td>{{data.twNoticeDetail}}</td>
        <td>{{data.enNoticeDetail}}</td>
        <td>{{data.vnNoticeDetail}}</td>
        <td>{{data.startTime}}</td>
        <td>{{data.endTime}}</td>
        <td style="text-align: center;" [nzRight]="true">
          <span nz-icon nzType="edit"  nzTheme="twotone" (click)="showModal(data)" style="font-size: 20px; cursor: pointer;"></span>
        </td>
        <!-- <td><button nz-button [nzType]="'primary'" (click)="showModal(data)"  class="default-button"><span>edit</span></button></td> -->
        <td style="text-align: center;" [nzRight]="true">
          <span nz-icon  nzType="delete" nzTheme="twotone" (click)="deletedata(data)" style="font-size: 20px; cursor: pointer;"></span>
        </td>
        
        <!-- <td><button nz-button [nzType]="'primary'" (click)="deletedata(data)"  class="default-button"><span>delete</span></button></td> -->
      </tr>
    </tbody>
  </nz-table>
  <nz-pagination style="float:right;" [(nzPageIndex)]="pageIndex" [nzTotal]="nzTotal" [nzSize]="'small'"
    nzShowSizeChanger [nzPageSizeOptions]="[10, 20, 50,100]" [nzPageSize]='pageSize'
    (nzPageSizeChange)="nzPageSizeChange($event)"  
    (nzPageIndexChange)="nzPageIndexChange($event)"></nz-pagination>
    <ng-template #renderItemTemplate let-type let-page="page">
         
      <a *ngIf="type === 'page'">{{ page }}</a>
      <a *ngIf="type === 'prev'" [style.color]="'black'">&#60;</a>
      <a *ngIf="type === 'next'" [style.color]="'black'">&#62;</a>
    </ng-template>
</div>

<nz-modal [(nzVisible)]="isVisible" nzTitle="{{'EditAnnouncementContent'|translate}}" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()" nzOkText="{{'Submit'|translate}}" nzCancelText="{{'cancel'|translate}}" >
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="validateForm">
      <div nz-row>
        <div nz-col [nzXs]="{ span: 5, offset: 1 }" [nzLg]="{ span: 6, offset: 2 }">
          <nz-form-item>
            <nz-form-label nzSpan="8" >
              <div class="width-100-percent label-font" class="text-ellipsis" title="{{'Bulletin type' | translate }}">{{ "Bulletin type" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16"  >
              <nz-select formControlName="Type" (ngModelChange)="ngModelChange()" >
                <nz-option nzValue="1" nzLabel="{{'ExternalAnnouncement'|translate}}" ></nz-option>
                <nz-option nzValue="0" nzLabel="{{'InternalAnnouncement'|translate}}"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row >

        <div nz-col [nzXs]="{ span: 3, offset: 1 }" [nzLg]="{ span: 6, offset: 2 }" *ngIf="select">
          <nz-form-item>
            <nz-form-label nzSpan="8">
              <div class="width-100-percent label-font" class="text-ellipsis" title="{{'Site' | translate }}">{{ "Site" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16"  >
              <nz-select formControlName="Site"   nzMode="multiple"  [nzDisabled]="siteDisabled">
                <nz-option *ngFor="let option of SiteList" [nzValue]="option.siteName" [nzLabel]="option.siteName" ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzXs]="{ span: 3, offset: 1 }" [nzLg]="{ span: 6, offset: 2 }"  *ngIf="select2">
          <nz-form-item>
            <nz-form-label nzSpan="8">
              <div class="width-100-percent label-font"  class="text-ellipsis" title="{{'Site' | translate }}">{{ "Site" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16"  >
              <nz-select formControlName="Site" [nzDisabled]="siteDisabled" >
                <nz-option *ngFor="let option of SiteList" [nzValue]="option.siteName" [nzLabel]="option.siteName" ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>

      </div>
      
      <div nz-row >
        <div nz-col [nzXs]="{ span: 5, offset: 1 }" [nzLg]="{ span: 6, offset: 2 }">
          <nz-form-item >
            <nz-form-label nzSpan="8" >
              <div class="width-100-percent label-font" class="text-ellipsis" title="{{'StartTime' | translate }}" >{{ "StartTime" | translate}}{{ "From" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16"  >
              <nz-date-picker
              formControlName="startDate"
              [nzDisabledDate]="disabledStartDate"

              style="width: 100%;"
              nzPlaceHolder="Start"
              (nzOnOpenChange)="handleStartOpenChange($event)"
              
            ></nz-date-picker>
              <!-- <nz-date-picker style="width: 100%;" [nzPlaceHolder]="'填写开始时间'| translate"   formControlName="startDate"></nz-date-picker> -->
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="6">
          <nz-form-item >
            <nz-form-label nzSpan="8">
              <div class="width-100-percent label-font" class="text-ellipsis" title="{{'EndTime' | translate }}" >{{ "EndTime" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16">
              <nz-date-picker
              formControlName="Edatetime"
              #endDatePicker
              [nzDisabledDate]="disabledEndDate"
              style="width: 100%;"
              nzPlaceHolder="End"
              (nzOnOpenChange)="handleEndOpenChange($event)"
              
            ></nz-date-picker>
              <!-- <nz-date-picker style="width: 100%;" [nzPlaceHolder]="'填写结束时间'| translate"  formControlName="Edatetime" [nzDisabledDate]="disabledDate"></nz-date-picker> -->
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row>
        <div nz-col [nzXs]="{ span: 5, offset: 2 }" [nzLg]="{ span: 6, offset: 2 }">
          <nz-form-item>
            <nz-form-label nzSpan="8">
              <div class="width-100-percent label-font" class="text-ellipsis" title="{{'BulletinTitle' | translate }}"  >{{ "BulletinTitle" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16">
              <input nz-input placeholder="{{'inputCN'|translate}}" formControlName="CNTitle"  />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzXs]="{ span: 5, offset: 2 }" [nzLg]="{ span: 6, offset: 2 }">
          <nz-form-item>
            <nz-form-control nzSpan="16">
              <input nz-input placeholder="{{'inputTW'|translate}}" formControlName="TWTitle" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzXs]="{ span: 5, offset: 2 }" [nzLg]="{ span: 6, offset: 2 }"  style="margin-left: -20px;">
          <nz-form-item>
            <nz-form-control nzSpan="16">
              <input nz-input placeholder="{{'inputEN'|translate}}" formControlName="ENTitle" />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row>
        <div nz-col [nzXs]="{ span: 5, offset: 2 }" [nzLg]="{ span: 6, offset: 2 }">
          <nz-form-item>
            <nz-form-label nzSpan="8">
              <div class="width-100-percent label-font" class="text-ellipsis" title="{{'text' | translate }}" >{{ "text" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16">
              <textarea rows="6" nz-input  formControlName="CNText"
                placeholder="{{'inputCN'|translate}}"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzXs]="{ span: 5, offset: 2 }" [nzLg]="{ span: 6, offset: 2 }">
          <nz-form-item>
            <nz-form-control nzSpan="16">
              <textarea rows="6" nz-input  formControlName="TWText"
                placeholder="{{'inputTW'|translate}}"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzXs]="{ span: 5, offset: 2 }" [nzLg]="{ span: 6, offset: 2 }" style="margin-left: -20px;">
          <nz-form-item>
            <nz-form-control nzSpan="16">
              <textarea rows="6" nz-input  formControlName="ENText"
                placeholder="{{'inputEN'|translate}}"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div  nz-row >
        <div nz-col nzSpan="2"></div>
        <div nz-col [nzXs]="{ span: 5, offset: 2 }" [nzLg]="{ span: 6, offset: 2 }">
          <nz-form-item>
            <nz-form-control nzSpan="16">
              <input nz-input placeholder="{{'PleaseEnterVietnamese'|translate}}" formControlName="VNTitle"  />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div  nz-row >
        <div nz-col nzSpan="2"></div>
        <div nz-col [nzXs]="{ span: 5, offset: 2 }" [nzLg]="{ span: 6, offset: 2 }" >
          <nz-form-item>
            <nz-form-control nzSpan="16">
              <textarea rows="6" nz-input  formControlName="VNText"
                placeholder="{{'PleaseEnterVietnamese'|translate}}"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
     
      <!-- <div nz-row>
        <div nz-col nzspan="12">
        </div>
        <div nz-col nzspan="6">
          <button nz-button nzType="primary" class="default-button" (click)="Submit()">{{'Submit'|translate}}</button>
        </div>
      </div> -->
    </form>
  </ng-container>

</nz-modal>

</nz-card>
</nz-spin>